import React from 'react';

const pub = process.env.PUBLIC_URL || '';

function toWebpPath(path) {
  return path.replace(/\.(png|jpe?g|avif)$/i, '.webp');
}

/**
 * Raster images: single WebP src. Pass paths from public/ using .webp (or legacy .png/.jpg — normalized to .webp).
 * SVG: passed through unchanged.
 */
export default function PictureImage({
  src,
  alt = '',
  className,
  imgClassName,
  sizes,
  loading,
  fetchPriority,
}) {
  const path = src.startsWith('/') ? src : `/${src}`;

  if (/\.svg$/i.test(path)) {
    return (
      <img
        src={`${pub}${path}`}
        alt={alt}
        className={imgClassName || className}
        loading={loading}
        fetchPriority={fetchPriority}
        sizes={sizes}
        decoding="async"
      />
    );
  }

  const webpPath = /\.webp$/i.test(path) ? path : toWebpPath(path);
  const resolved = `${pub}${webpPath}`;

  return (
    <img
      src={resolved}
      alt={alt}
      className={imgClassName || className}
      sizes={sizes}
      loading={loading}
      fetchPriority={fetchPriority}
      decoding="async"
    />
  );
}
